/**
 * @Author:
 * @Description:
 * @DateTime: Created in 08:23 2019-07-15
 */

import EnumItem, {enumMixn} from "./enumItem";

/**
 * 运维审核类型
 */
let EnumExceptionStatus = {
	已下达: 						new EnumItem('已下达', 0),
    已处理: 						new EnumItem('已处理', 1),
	...enumMixn
}
export default EnumExceptionStatus

export let EnumExceptionTaskStatus = {
    待派发: new EnumItem('待派发', 0),
    已派发: new EnumItem('已派发', 1),
    已处理: new EnumItem('已处理', 2),
    // 已反馈: new EnumItem('已反馈', 3),
    ...enumMixn,
};

export const EnumExceptionTaskDealStatus = {
    已处理: new EnumItem('已处理', 2),
    未处理: new EnumItem('未处理', 1),
    ...enumMixn,
};
